import { EnvironmentSettings, EnvironmentType } from '../types';

export const baseStagingEnvironment: EnvironmentSettings = {
  aaptivUserPortalUrl: 'https://my.aapdev.com',
  aaptivServiceUrl: 'https://skyfit.aapdev.com',
  defaultTenantId: '64f791c6d14d7ff99013f4af',
  aaptivEnterpriseId: '650ca213d6895d0f9004ac3d',
  productionMode: true,
  repTime: 4,
  sentryDsn:
    'https://6bcb7dc730bb44858a6b20f99d895a03@o367782.ingest.us.sentry.io/5176798',
  sentryServiceTag: 'admin-ui',
  serverEnvironment: EnvironmentType.staging,
};
